import { Scorecard } from '../../scorecard-next.model';
import { ScorecardDto } from '../../scorecard.model';

import { HistoryPosition } from './history-position.model';

export function createHistoryPosition(
    history: ScorecardDto[],
    currentScorecard: Scorecard,
): HistoryPosition {
    try {
        const index = history.indexOf(currentScorecard.header);
        const isAtFirst = index === 0;
        const isAtLast = index === history.length - 1;
        return {
            index,
            isAtFirst,
            isAtLast,
        };
    } catch {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {} as HistoryPosition;
    }
}
